import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {TextPlugin} from 'gsap/TextPlugin'
// import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(SplitText)
gsap.registerPlugin(TextPlugin) 

export default class Animations {
  static init() {
    console.debug('== Animations components ==')

    // const main = document.querySelector('.main-wrapper')

    // // Homepage hero animation
    // if (main.classList.contains('front-page')) {
    //   console.debug('  -> Animate main viewport')

    //   const headerWrapper = document.querySelector('.header-wrapper')
    //   const sectionHero = document.querySelector('.section--hero')

    //   const tlMainViewport = gsap.timeline()
    //   tlMainViewport
    //     .from(sectionHero, {
    //       autoAlpha: 0,
    //       delay: 0.125,
    //       duration: 1,
    //       ease: 'expo.out',
    //     })
    //     .from(headerWrapper, {
    //       autoAlpha: 0,
    //       delay: -0.725,
    //       duration: 1,
    //       ease: 'expo.out',
    //     })
    // }

    // General animations
    console.debug('  -> Animate general components')

    const animateRight = document.querySelectorAll('.animate-right')
    if (animateRight.length != 0) {
      animateHorizontal(animateRight, 20)
    }

    const animateLeft = document.querySelectorAll('.animate-left')
    if (animateLeft.length != 0) {
      animateHorizontal(animateLeft, -20)
    }

    const animateBottom = document.querySelectorAll('.animate-bottom')
    if (animateBottom.length != 0) {
      animateVertical(animateBottom, 20)
    }

    const animateTop = document.querySelectorAll('.animate-top')
    if (animateTop.length != 0) {
      animateVertical(animateTop, -20)
    }

    const animateFadeItems = document.querySelectorAll('.animate-fade')
    if (animateFadeItems.length != 0) {
      animateFade(animateFadeItems)
    }

    const animateBottomStagger = document.querySelectorAll('.animate-bottom-stagger')
    if (animateBottomStagger.length != 0) {
      animateInStaggerBottom(animateBottomStagger, 20, 0.15)
    }

    const animateSpreadImages = document.querySelectorAll('.animate-spread-images')
    if (animateSpreadImages.length != 0) {
      animateInSpreadImages(animateSpreadImages)
    }
  }

  static destroyScrolls() {
    ScrollTrigger.killAll()
  }
}

function animateHorizontal(items, offset) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({ autoRemoveChildren: true, paused: true })

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      x: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateVertical(items, offset, start = 'top 95%') {
  items.forEach((item) => {
    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      y: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: start,
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateFade(items) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

const animateInStaggerBottom = (items) => {
  items.forEach((item) => {
    gsap.set(item, { autoAlpha: 1, y: 0 })

    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})
    let stItem = null

    // Select subitems within the main item
    const subitems = Array.from(
      item.querySelectorAll('.animate-stagger-item')
    )
    
    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity';

    if( subitems.length > 0 ){
      tlItem.from(subitems, {
        [property]: 0,
        duration: 0.75,
        y: 100,
        ease: 'Power2.easeOut',
        stagger: 0.2,
        onComplete: () => {
          stItem.kill()
          item.classList.remove('.animate-in-stagger-item')
        },
      })
  
      stItem = ScrollTrigger.create({
        trigger: item,
        start: 'top 70%',
        animation: tlItem,
        // markers: true,
        toggleActions: 'play none none none',
      })
    }
  })
}

const animateInSpreadImages = (items) => {
  items.forEach((item) => {
    // Configura i media query con GSAP matchMedia
    const mm = gsap.matchMedia();

    mm.add(
      {
        isMobile: '(max-width: 575px)',
        isDesktop: '(min-width: 576px)',
      },
      (context) => {
        const { isMobile } = context.conditions;

        let tlItem = gsap.timeline({ paused: true });

        const imageLeft = item.querySelector('.image-left')
        const imageRight = item.querySelector('.image-right')

        // Imposta i punti di partenza delle immagini
        gsap.set(imageLeft, { x: '0' })
        gsap.set(imageRight, { x: '0' })

        const shift = isMobile ? '5%' : '30%'

        tlItem
          .to(imageLeft, { x: `-${shift}`, duration: 1, ease: 'power2.out' }, 0)
          .to(imageRight, { x: shift, duration: 1, ease: 'power2.out' }, 0);

        ScrollTrigger.create({
          trigger: item,
          start: 'top 70%',
          end: 'bottom',
          animation: tlItem,
          markers: false,
          toggleActions: 'play reverse play reverse',
        })
      }
    )
  })
}